function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4 4V2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V4h21a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3h-5v-2h5a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h5v2H3a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1zm12 24a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-2a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm10-14a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
});

var SvgCamera = function SvgCamera(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "e2704873b5f25403219bba46824171ba.svg";
export { SvgCamera as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/camera.svg
// module id = null
// module chunks = 